import { motion } from 'framer-motion';
import { programs } from './programsData';
import ProgramCard from './ProgramCard';
import TestimonialSlider from './TestimonialSlider';

export default function FeaturedPrograms() {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-8">
          {/* Programs Section */}
          <div className="col-span-12 lg:col-span-7">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
            >
              <div className="bg-white rounded-xl p-6 shadow-md">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Featured Program</h2>
                <p className="text-gray-600 mb-6">
                  Discover our specialized training in climate finance
                </p>
                {programs.map((program, index) => (
                  <ProgramCard key={program.title} program={program} index={index} />
                ))}
              </div>
            </motion.div>
          </div>

          {/* Testimonials Section */}
          <div className="col-span-12 lg:col-span-5">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="h-full"
            >
              <div className="h-full bg-gradient-to-br from-green-900 to-emerald-800 rounded-xl shadow-xl overflow-hidden">
                {/* Decorative Top Border */}
                <div className="h-1 bg-gradient-to-r from-green-400 to-emerald-400" />
                
                {/* Content Container */}
                <div className="p-6">
                  <TestimonialSlider />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}